import { combineReducers } from "@reduxjs/toolkit";

import details from "./detailsReducer";
import latest from "./latestReducer";

export default combineReducers({
  latest,
  details
});
